export default __webpack_public_path__ + "assets/fonts/Londrina-Solid-regular.svg";